module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-about"
  }, [_c('div', {
    ref: "overlay",
    staticClass: "overlay"
  }), _vm._v(" "), _c('navigation'), _vm._v(" "), _c('div', {
    ref: "about",
    staticClass: "section-title"
  }, [_vm._v("About")]), _vm._v(" "), _c('about-content')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f7354a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 169
// module chunks = 1